/* CF: Quote cart (Trello: Request a Quote - Mini Cart & Cart Button).
   When the cart has a quote-only item (Franklin Electric):
   - those lines show "Price on invoice" and the totals show "Final total on your invoice"
   - Checkout buttons are replaced by "Get my invoice", which opens a short form
   - the form sends the whole cart to the quote service (/draft-order-cart), which emails one invoice
   Carts without quote items are not touched. */
(function () {
  if (window.cfqcReady) return;
  window.cfqcReady = true;

  var cfqcConfig = {
    endpoint: 'https://request-draft.cleanflow.net/draft-order-cart',
    vendors: ['franklin electric'],
    turnstileSiteKey: '0x4AAAAAAD8LBhWnqBgDlILg',
    turnstileAction: 'draft_order',
    text: {
      linePrice: 'Price on invoice',
      total: 'Final total on your invoice',
      button: 'Get my invoice',
      sending: 'Sending… this can take up to 30 seconds',
      success: 'Thank you! Your invoice is on its way. Please check your inbox in the next few minutes (and your junk or spam folder). You can pay for everything in one go from the invoice.',
      pending: 'Thank you! We received your request and your invoice is being prepared. Our team will email it to you shortly, so there is no need to send the form again.',
      turnstileRequired: 'Please complete the security check.',
      turnstileFailed: 'The security check failed or expired. Please try again.',
      unavailable: 'One of the items in your cart is no longer available. Please remove it and try again.',
      generic: 'Sorry, we could not create your invoice. Please try again or call us at 1-866-335-1078.',
      network: 'Network error. Please try again in a moment.'
    }
  };

  var cfqcProvinces = {
    CA: [['AB','Alberta'],['BC','British Columbia'],['MB','Manitoba'],['NB','New Brunswick'],['NL','Newfoundland and Labrador'],['NS','Nova Scotia'],['NT','Northwest Territories'],['NU','Nunavut'],['ON','Ontario'],['PE','Prince Edward Island'],['QC','Quebec'],['SK','Saskatchewan'],['YT','Yukon']],
    US: [['AL','Alabama'],['AK','Alaska'],['AZ','Arizona'],['AR','Arkansas'],['CA','California'],['CO','Colorado'],['CT','Connecticut'],['DE','Delaware'],['DC','District of Columbia'],['FL','Florida'],['GA','Georgia'],['HI','Hawaii'],['ID','Idaho'],['IL','Illinois'],['IN','Indiana'],['IA','Iowa'],['KS','Kansas'],['KY','Kentucky'],['LA','Louisiana'],['ME','Maine'],['MD','Maryland'],['MA','Massachusetts'],['MI','Michigan'],['MN','Minnesota'],['MS','Mississippi'],['MO','Missouri'],['MT','Montana'],['NE','Nebraska'],['NV','Nevada'],['NH','New Hampshire'],['NJ','New Jersey'],['NM','New Mexico'],['NY','New York'],['NC','North Carolina'],['ND','North Dakota'],['OH','Ohio'],['OK','Oklahoma'],['OR','Oregon'],['PA','Pennsylvania'],['RI','Rhode Island'],['SC','South Carolina'],['SD','South Dakota'],['TN','Tennessee'],['TX','Texas'],['UT','Utah'],['VT','Vermont'],['VA','Virginia'],['WA','Washington'],['WV','West Virginia'],['WI','Wisconsin'],['WY','Wyoming']]
  };

  var cfqcItems = [];
  var cfqcHasQuote = false;
  var cfqcObserver = null;
  var cfqcTimer = null;

  function cfqcNorm(value) {
    return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function cfqcIsQuoteVendor(value) {
    return cfqcConfig.vendors.indexOf(cfqcNorm(value)) > -1;
  }

  function cfqcLoadCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        cfqcItems = cart.items || [];
        cfqcHasQuote = cfqcItems.some(function (item) { return cfqcIsQuoteVendor(item.vendor); });
        return cart;
      });
  }

  function cfqcSetNote(element, text) {
    if (element.dataset.cfqcDone === '1') return;
    element.dataset.cfqcDone = '1';
    element.innerHTML = '';
    var note = document.createElement('span');
    note.className = 'cfqc-price-note';
    note.textContent = text;
    element.appendChild(note);
  }

  function cfqcDecorate() {
    document.documentElement.classList.toggle('cfqc-has-quote', cfqcHasQuote);
    if (!cfqcHasQuote) return;

    document.querySelectorAll('tr.line-item, .mini-cart__line-item').forEach(function (row) {
      var vendorLink = row.querySelector('.line-item__vendor, .mini-cart__product-vendor');
      if (!vendorLink || !cfqcIsQuoteVendor(vendorLink.textContent)) return;
      row.querySelectorAll('.line-item__price-list, .line-item__line-price, .mini-cart__price-list').forEach(function (priceElement) {
        cfqcSetNote(priceElement, cfqcConfig.text.linePrice);
      });
    });

    document.querySelectorAll('.cart-recap__price-line-price, .mini-cart__recap-price-line > span:last-child').forEach(function (totalElement) {
      cfqcSetNote(totalElement, cfqcConfig.text.total);
    });

    document.querySelectorAll('button[name="checkout"]').forEach(function (checkoutButton) {
      if (checkoutButton.dataset.cfqcDone === '1') return;
      checkoutButton.dataset.cfqcDone = '1';
      checkoutButton.hidden = true;
      var invoiceButton = document.createElement('button');
      invoiceButton.type = 'button';
      invoiceButton.className = checkoutButton.className.replace('cart-recap__checkout', '') + ' cfqc-invoice-button';
      invoiceButton.textContent = cfqcConfig.text.button;
      invoiceButton.addEventListener('click', cfqcOpenForm);
      checkoutButton.insertAdjacentElement('afterend', invoiceButton);
    });
  }

  function cfqcRefresh() {
    clearTimeout(cfqcTimer);
    cfqcTimer = setTimeout(function () {
      cfqcLoadCart().then(function () {
        if (cfqcObserver) cfqcObserver.disconnect();
        cfqcDecorate();
        cfqcWatch();
      }).catch(function () { /* leave the cart as it is */ });
    }, 300);
  }

  function cfqcWatch() {
    if (!cfqcObserver) {
      cfqcObserver = new MutationObserver(function (mutations) {
        var cartChanged = mutations.some(function (mutation) {
          var target = mutation.target;
          return target.closest && target.closest('#mini-cart, .cart-wrapper, .cart-recap, [data-section-type="cart"], main');
        });
        if (cartChanged) cfqcRefresh();
      });
    }
    cfqcObserver.observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- "Get my invoice" form ---------- */

  var cfqcModal = null;

  function cfqcField(label, name, type, required, extra) {
    return '<label class="cfqc-field' + (extra && extra.full ? ' cfqc-field--full' : '') + '"><span>' + label + (required ? ' *' : '') + '</span>' +
      (type === 'textarea'
        ? '<textarea name="' + name + '" rows="2" maxlength="2000"' + (required ? ' required' : '') + '></textarea>'
        : type === 'country'
          ? '<select name="' + name + '" required><option value="CA" selected>Canada</option><option value="US">United States</option></select>'
          : type === 'province'
            ? '<select name="' + name + '" required></select>'
            : '<input type="' + type + '" name="' + name + '"' + (extra && extra.auto ? ' autocomplete="' + extra.auto + '"' : '') + (required ? ' required' : '') + '>') +
      '</label>';
  }

  function cfqcBuildModal() {
    cfqcModal = document.createElement('div');
    cfqcModal.className = 'cfqc-modal';
    cfqcModal.hidden = true;
    cfqcModal.innerHTML =
      '<div class="cfqc-modal__backdrop" data-cfqc-close></div>' +
      '<form class="cfqc-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="cfqc-title" novalidate>' +
        '<button type="button" class="cfqc-modal__close" data-cfqc-close aria-label="Close">&times;</button>' +
        '<h2 id="cfqc-title" class="cfqc-modal__title">Get my invoice</h2>' +
        '<p class="cfqc-modal__intro">Some items in your cart are priced on request. Enter your details and we will email you one invoice for your whole cart, with your final prices, taxes and shipping.</p>' +
        '<div class="cfqc-grid">' +
          cfqcField('Email', 'email', 'email', true, { auto: 'email' }) +
          cfqcField('Country', 'countryCode', 'country', true) +
          cfqcField('First name', 'firstName', 'text', true, { auto: 'given-name' }) +
          cfqcField('Last name', 'lastName', 'text', true, { auto: 'family-name' }) +
          cfqcField('Company', 'company', 'text', false, { auto: 'organization' }) +
          cfqcField('Phone', 'phone', 'tel', false, { auto: 'tel' }) +
          cfqcField('Address', 'address1', 'text', true, { full: true, auto: 'address-line1' }) +
          cfqcField('Apartment, suite, etc.', 'address2', 'text', false, { auto: 'address-line2' }) +
          cfqcField('City', 'city', 'text', true, { auto: 'address-level2' }) +
          cfqcField('Province / State', 'provinceCode', 'province', true) +
          cfqcField('Postal / ZIP code', 'postalCode', 'text', true, { auto: 'postal-code' }) +
          cfqcField('Message', 'customerMessage', 'textarea', true, { full: true }) +
        '</div>' +
        '<div class="cfqc-turnstile"></div>' +
        '<p class="cfqc-message" role="status" aria-live="polite" hidden></p>' +
        '<button type="submit" class="button button--primary button--full cfqc-submit">' + cfqcConfig.text.button + '</button>' +
      '</form>';
    document.body.appendChild(cfqcModal);

    cfqcModal.addEventListener('click', function (event) {
      if (event.target.closest('[data-cfqc-close]')) cfqcCloseForm();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && cfqcModal && !cfqcModal.hidden) cfqcCloseForm();
    });
    cfqcModal.querySelector('form').addEventListener('submit', cfqcSubmit);

    var countrySelect = cfqcModal.querySelector('[name="countryCode"]');
    cfqcFillProvinces(countrySelect.value);
    countrySelect.addEventListener('change', function () { cfqcFillProvinces(countrySelect.value); });
  }

  function cfqcFillProvinces(countryCode) {
    var provinceSelect = cfqcModal.querySelector('[name="provinceCode"]');
    provinceSelect.innerHTML = '';
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = countryCode === 'US' ? 'Select a state' : 'Select a province';
    provinceSelect.appendChild(placeholder);
    (cfqcProvinces[countryCode] || []).forEach(function (entry) {
      var option = document.createElement('option');
      option.value = entry[0];
      option.textContent = entry[1];
      provinceSelect.appendChild(option);
    });
  }

  var cfqcTurnstileWidget = null;
  var cfqcSent = false;

  function cfqcRenderTurnstile() {
    var container = cfqcModal.querySelector('.cfqc-turnstile');
    function render() {
      if (cfqcTurnstileWidget !== null || !window.turnstile) return;
      cfqcTurnstileWidget = window.turnstile.render(container, {
        sitekey: cfqcConfig.turnstileSiteKey,
        action: cfqcConfig.turnstileAction,
        size: 'flexible',
        'refresh-expired': 'auto'
      });
    }
    if (window.turnstile) { render(); return; }
    if (!document.querySelector('script[data-cfqc-turnstile]')) {
      var script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.dataset.cfqcTurnstile = '1';
      script.onload = render;
      document.head.appendChild(script);
    }
  }

  function cfqcOpenForm() {
    if (!cfqcModal) cfqcBuildModal();
    cfqcModal.hidden = false;
    document.documentElement.classList.add('cfqc-lock');
    cfqcRenderTurnstile();
    var firstInput = cfqcModal.querySelector('input[name="email"]');
    if (firstInput) firstInput.focus();
  }

  function cfqcCloseForm() {
    cfqcModal.hidden = true;
    document.documentElement.classList.remove('cfqc-lock');
    if (cfqcSent) window.location.reload();
  }

  function cfqcShowMessage(text, isSuccess) {
    var message = cfqcModal.querySelector('.cfqc-message');
    message.textContent = text;
    message.hidden = false;
    message.classList.toggle('cfqc-message--ok', !!isSuccess);
  }

  function cfqcSubmit(event) {
    event.preventDefault();
    var form = event.currentTarget;
    if (!form.checkValidity()) { form.reportValidity(); return; }

    var token = window.turnstile && cfqcTurnstileWidget !== null ? window.turnstile.getResponse(cfqcTurnstileWidget) : '';
    if (!token) { cfqcShowMessage(cfqcConfig.text.turnstileRequired); return; }

    var data = new FormData(form);
    var payload = { turnstileToken: token, items: [] };
    ['email', 'countryCode', 'provinceCode', 'firstName', 'lastName', 'company', 'address1', 'address2', 'city', 'postalCode', 'phone', 'customerMessage'].forEach(function (name) {
      payload[name] = String(data.get(name) || '').trim();
    });

    var submitButton = form.querySelector('.cfqc-submit');
    submitButton.disabled = true;
    submitButton.textContent = cfqcConfig.text.sending;

    cfqcLoadCart().then(function () {
      payload.items = cfqcItems.map(function (item) { return { variantId: String(item.variant_id), quantity: item.quantity }; });
      return fetch(cfqcConfig.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (result) { return { ok: response.ok, result: result }; });
    }).then(function (reply) {
      var cfqcInvoicePending = reply.result.code === 'INVOICE_SEND_FAILED';
      if ((!reply.ok || !reply.result.success) && !cfqcInvoicePending) {
        var code = reply.result.code || '';
        if (code.indexOf('TURNSTILE') === 0) cfqcShowMessage(cfqcConfig.text.turnstileFailed);
        else if (code === 'VARIANT_NOT_FOUND' || code === 'PRODUCT_NOT_AVAILABLE') cfqcShowMessage(cfqcConfig.text.unavailable);
        else cfqcShowMessage(cfqcConfig.text.generic);
        return;
      }
      cfqcSent = true;
      form.querySelector('.cfqc-grid').hidden = true;
      form.querySelector('.cfqc-turnstile').hidden = true;
      submitButton.hidden = true;
      cfqcShowMessage(cfqcInvoicePending ? cfqcConfig.text.pending : cfqcConfig.text.success, true);
      return fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' });
    }).catch(function () {
      cfqcShowMessage(cfqcConfig.text.network);
    }).then(function () {
      if (!cfqcSent) {
        submitButton.disabled = false;
        submitButton.textContent = cfqcConfig.text.button;
        if (window.turnstile && cfqcTurnstileWidget !== null) window.turnstile.reset(cfqcTurnstileWidget);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', cfqcRefresh);
  if (document.readyState !== 'loading') cfqcRefresh();
  cfqcWatch();
})();
